import * as yup from 'yup';
import dayjs from 'dayjs';

export const RotateCaptainConf = {
    schema: {
        start_date: yup
            .date()
            .nullable()
            .transform((value, originalValue) => {
                const parsedDate = dayjs(originalValue, 'YYYY-MM-DD', true);
                return parsedDate?.isValid() ? parsedDate.toDate() : null;
            }),
        end_date: yup
            .date()
            .nullable()
            .when('start_date', (start_date, schema) =>
                start_date
                    ? schema.min(dayjs(start_date), "End date can't be before Start date")
                    : schema
            )
            .transform((value, originalValue) => {
                const parsedDate = dayjs(originalValue, 'YYYY-MM-DD', true);
                return parsedDate?.isValid() ? parsedDate.toDate() : null;
            }),
    },
    defaultValues: {
        start_date: null,
        end_date: null,
    },
    fields: [
        {
            id: 'start_date',
            name: 'start_date',
            type: 'date',
            label: 'Start Date',
            required: false,
            xs: 12,
            sm: 6,
        },
        {
            id: 'end_date',
            name: 'end_date',
            type: 'date',
            label: 'End Date',
            required: false,
            xs: 12,
            sm: 6,
        },
    ],
};
